<template>
  <v-dialog v-model="dialogd" max-width="420px" persistent>
    <div class="modal-wrapper">
      <img src="@/assets/bg-cta.png" alt="Background" class="modal-background" />
      
      <div class="modal-content">
        <v-btn icon class="close-btn" @click="closeModalDone" dark>
          <v-icon>mdi-close</v-icon>
        </v-btn>

        <h3 class="form-title">Parabéns, {{ nomeInscrito }}!</h3>
        <h2 class="modal-title">
          <p>Você garantiu sua vaga e deu o primeiro passo para descobrir se o Estado está te devendo!</p>
          <p style="font-weight: 650;">O próximo passo é essencial!<br />Você precisa entrar no grupo de Whatsapp da palestra para ter acesso ao link da transmissão e mais informações.</p>
        </h2>
        
        <v-form ref="form" class="modal-form">
          <v-btn
            class="submit-btnx"
            large
            block
            @click="submitForm"
          >
            <v-icon>mdi-whatsapp</v-icon> Entrar no grupo do Whatsapp
          </v-btn>
        </v-form>
      </div>
    </div>
  </v-dialog>
</template>

<script>
export default {
  name: 'ConfirmadoModal',
  props: {
    visible: {
      type: Boolean,
      default: false
    }
  },

  watch: {
    visible(newVal) {
      this.dialogd = newVal;
    },
    dialogd(newVal) {
      if (!newVal) {
        this.$emit('update:visible', false);
      }
    }
  },
  
  data() {
    return {
      dialogd: false,
      nomeInscrito: localStorage.getItem('meuNome') || '',
    };
  },

  methods: {
    openModal() {
      this.dialogd = true;
    },
    
    closeModalDone() {
      this.dialogd = false;
      setTimeout(() => {
        this.$emit('end', true);
      }, 2000);
    },
    
    resetForm() {
      if (this.$refs.form) {
        this.$refs.form.reset();
      }
    },
    
    submitForm() {
      window.open('https://chat.whatsapp.com/LiEAm726EwK09EfLD7nDAw?mode=wwc', '_blank');
      this.closeModalDone();
      console.log('Acessou whatsapp');
    },
  }
};
</script>

<style scoped>
.modal-wrapper {
  position: relative;
  overflow: hidden;
  border-radius: 4px;
}

.modal-background {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  object-fit: cover;
  z-index: 0;
}

.modal-content {
  position: relative;
  z-index: 1;
  padding: 40px 30px;
  color: white;
}

.close-btn {
  position: absolute;
  top: 10px;
  right: 10px;
  z-index: 2;
}

.modal-title {
  font-size: 18px;
  font-weight: 500;
  line-height: 1.3;
  margin-bottom: 16px;
  color: white;
}

.modal-subtitle {
  font-size: 16px;
  line-height: 1.4;
  margin-bottom: 24px;
  color: white;
}

.form-title {
  text-align: center;
  font-size: 20px;
  font-weight: 400;
  margin-bottom: 24px;
  color: #D4B896;
}

.modal-form {
  margin-top: 20px;
}

.form-field {
  margin-bottom: 16px;
}

.form-field >>> .v-input__control {
  background-color: rgba(255, 255, 255, 0.9);
  border-radius: 4px;
}

.form-field >>> .v-label {
  color: rgba(0, 0, 0, 0.6) !important;
  font-size: 14px;
}

.form-field >>> .v-text-field__slot input {
  color: #000;
}

.submit-btnx {
  background-color: #B8956A !important;
  margin-top: 20px;
  font-weight: 700;
  text-transform: none;
  letter-spacing: 0.5px;
  color: #521817 !important;
}
</style>